<div class="signed-amount-input input-group"
  [class.signed-amount-input--no-operator]="!showOperatorButton">
  <div class="input-group-prepend" *ngIf="showOperatorButton">
    <button
      type="button"
      class="signed-amount-input__operator-btn"
      [class.signed-amount-input__operator-btn--negative]="operator === '-'"
      (click)="toggleOperator()"
      [disabled]="isOperatorDisabled">
      {{ operator }}
    </button>
  </div>

  <div
    class="signed-amount-input__field"
    [class.signed-amount-input__field--disabled]="isInputDisabled"
    [class.signed-amount-input__field--full-width]="!showOperatorButton">
    <input
      type="text"
      [ngClass]="inputClass"
      class="signed-amount-input__input"
      appNumberWithCommaSeparator
      [bracketNegative]="operator === '-'"
      [allowDecimals]="allowDecimals"
      [maxDecimalPlaces]="maxDecimalPlaces"
      [selectEndOnFocus]="true"
      [ngModel]="displayValue"
      (ngModelChange)="onAmountChange($event)"
      (blur)="onBlur()"
      [disabled]="isInputDisabled" />
  </div>
</div>
